import CommentIcon from '@atlaskit/icon/core/comment';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import { getValueId } from '@databases/utils/utils';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';

export const commentsMenuItem: MenuItemBuilder = ({
  capabilities: { canOpenComments },
  comments: { setOpenThread },
  entryId,
  fieldId,
  formatMessage,
  panel,
}) => {
  return {
    isEnabled: () => canOpenComments,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.COMMENTS,
      content: formatMessage(messages['value-actions.comments']),
      onClick: () => {
        const valueId = getValueId(entryId, fieldId);

        setOpenThread({ valueId, create: true, panel });
      },
      closeOnClick: true,
      tooltipPosition: 'right',
      elemBefore: <CommentIcon label="" />,
      shortcut: SHORTCUTS.OPEN_COMMENTS,
    },
  };
};
